const emptyStringPattern = /\S/;
const checkIfStringEmpty = (value?: string): boolean => !value || !emptyStringPattern.test(value);

export default checkIfStringEmpty;
